module.exports = __webpack_public_path__ + "static/img/Lachie_Hunter_desktop.838e5cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Lachie_Hunter_desktop.jpg
// module id = gjls
// module chunks = 0